import { render, staticRenderFns } from "./StoryBoardMainAi.vue?vue&type=template&id=4191ae46&scoped=true"
import script from "./StoryBoardMainAi.vue?vue&type=script&lang=js"
export * from "./StoryBoardMainAi.vue?vue&type=script&lang=js"
import style0 from "./StoryBoardMainAi.vue?vue&type=style&index=0&id=4191ae46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191ae46",
  null
  
)

export default component.exports